import { render, staticRenderFns } from "./PricingExtras.vue?vue&type=template&id=3674c47a&scoped=true"
import script from "./PricingExtras.js?vue&type=script&lang=js&external"
export * from "./PricingExtras.js?vue&type=script&lang=js&external"
import style0 from "./PricingExtras.scss?vue&type=style&index=0&id=3674c47a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674c47a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
